import { TranslateService } from "@ngx-translate/core";
import { InitTask } from "./init-task.interface";
import { SplashManager } from "./splash-manager";

export async function runBootstrapTasks(tasks: InitTask[], translate: TranslateService) {
    tasks.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

    const total = tasks.length;
    let done = 0;

    for (const task of tasks) {
        const text = translate.instant(task.description) || task.description;
        SplashManager.setText(text);
        // await delay(2000);
        await task.run();
        done++;
        SplashManager.setProgress(Math.round((done / total) * 100));
    }
}

/** Метод для задержки загрузки для удобства верстки */
function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}